import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi.js";
import { useLang } from "../context/LangContext.js";
import servicesImage from "../assets/services.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEnvelope, faPhone} from "@fortawesome/free-solid-svg-icons";
import "../styles/services.css";

export default function Services() {
  const [content, setContent] = useState({});
  const { lang } = useLang();
  useEffect(() => {
    fetchPageContent("services", lang).then(data => setContent(data));
  }, [lang]);

  const services = [
    content.services,
    content.services_1,
    content.services_2,
    content.services_3,
    content.services_4,
    content.services_5,
    content.services_6,
    content.services_7,
    content.services_8,
    content.services_9,
    content.services_10,
    content.services_11,
    content.services_12
  ].filter(Boolean);

  if (!content) return <p>Loading...</p>;

  return (
   <section className="services-page">

         <h1 className="services-title">
  {content.services_title}
</h1>

<div className="services-intro">
  <p>{content.services_intro}</p>
</div>

<div className="gold-divider"></div>

      {/*Services List */}
        
       <div className="services-content">
    {/* Image */}
  <div className="services-story-image">
    <img
      src={servicesImage}
      alt="Shipbuilding services"
    />
  </div>

  <div className="services-list-section">

    <h2 className="services-list-title">
      {content.services_title_1}
    </h2>

    <div className="services-list">
      {services.map((service, idx) => (
        <div key={idx} className="services-item">
          ✔ {service}
        </div>
      ))}
    </div>

  </div>

</div>

<div className="gold-divider"></div>

<div className="services-bottom-section">
  <div className="services-bottom-text">
    <p>{content.services_text_1}</p>
    <p>{content.services_text_2}</p>
  </div>

{content.services_email && (
              <a href={`mailto:${content.services_email}`} className="footer-email">
                <FontAwesomeIcon icon={faEnvelope} /> {content.services_email}
              </a>
            )}
        {content.services_phone && (
         
          <div>
         <a className="services-contact" href={`tel:+${content.services_phone}`}>
            <FontAwesomeIcon icon={faPhone} /> + {content.services_phone}
          </a>
          </div>
        )}
        </div>

      <div className="spacer"/>
    
    </section>

  );

};